import QuickActionCard from "./QuickActionCard";

export default function QuickActionsWidget() {

  const actions = [
    {
      title: "Create Post",
      description:
        "Write and publish a new blog article.",
      to: "/admin/posts/create",
    },
    {
      title: "Create Banner",
      description:
        "Create a marketing banner campaign.",
      to: "/admin/banners/create",
    },
    {
      title: "View Analytics",
      description:
        "Review blog and marketing metrics.",
      to: "/admin/analytics",
    },
  ];

  return (
    <div>
      <h2 className="text-xl font-semibold mb-6">
        Quick Actions
      </h2>

      <div
        className="
          grid
          md:grid-cols-3
          gap-6
        "
      >
        {actions.map((action) => (
          <QuickActionCard
            key={action.title}
            {...action}
          />
        ))}
      </div>
    </div>
  );
}